import React, { useRef, useState } from 'react';
import { usePaginatedQueryV8 } from 'motion-components';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetQuery } from './graphql';
import { GridPage } from './grid';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useOnRouteChange } from 'shared-pages/hooks/common/useOnRouteChange';
//import { usePaginatedQueryV8 } from './paginated-query-v8';

export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.collectionPointId) {
      where = { ...where, collectionPointId: values.collectionPointId };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------------------------------------------- */
/* ------------------------ Page ----------------------------- */
export const CollectionsGridPage = observer(
  ({
    collectionPointId,
    collectionOrderId,
    isGridInForm = false,
    isModal = false,
    onClose,
  }: {
    collectionPointId?: number;
    collectionOrderId?: number;
    isGridInForm?: boolean;
    isModal?: boolean;
    onClose?: any;
  }) => {
    const { appStore, tableStore } = useRootStore();
    const { handleGraphqlError } = useHandleError('CollectionOrdersGridPage');

    const location = useLocation<any>();
    const history = useHistory();
    const [selected, setSelected] = useState<any>(null);
    const { t } = useTranslation();

    /* ------------------- Query ------------------------------- */
    const initOrderBy = 'dateCollected DESC';
    const query = usePaginatedQueryV8(
      gqlGetQuery,
      (values) => {
        return buildWhereFromFilterValues({ isActive: true, collectionPointId: collectionPointId });
      },
      initOrderBy,
      appStore,
      true,
      { isActive: true, collectionPointId: collectionPointId },
      false, // No History Replace
      'modal_collection_grid',
    );
    useOnRouteChange(() => {
      onClose();
    });
    const {
      loading,
      data,
      dataCount,
      error,
      initPageIndex,
      filtersChanged,
      gridPageChanged,
      queryState,
      queryParams,
      setQueryParams,
      refetch,
    } = query;

    const gridRef = useRef();

    if (error) {
      handleGraphqlError('query-get', error);
      return <h3 className="text-center">{error.message}</h3>;
    } else {
      return (
        <GridPage
          ref={gridRef}
          loading={loading}
          data={data}
          dataCount={dataCount}
          initPageIndex={initPageIndex}
          onPageChange={gridPageChanged}
          // initOrderBy={queryParams?.order ?? initOrderBy}
          initOrderBy={initOrderBy}
          onOrderChange={(orderBy) => {
            const newQueryParams = { ...queryParams, order: orderBy };
            // console.log('$$$-$', newQueryParams);
            setQueryParams(newQueryParams);
            // if (!isGridInForm) {
            //   history.replace({
            //     pathname: location.pathname,
            //     state: {
            //       ...location.state,
            //       order: orderBy,
            //     },
            //   });
            // }
          }}
          selected={selected}
          setSelected={setSelected}
          refetch={refetch}
          isGridInForm={isGridInForm}
        />
      );
    }
  },
);

